import { PropsWithChildren } from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import styles from './LandingBackground.module.scss'

type LandingBackgroundProps = PropsWithChildren<{
  className?: string
}>

export default function LandingBackground({
  children,
  className,
}: LandingBackgroundProps) {
  return (
    <div className={clsx(styles.container, className)}>
      <Image
        fill
        priority
        alt="background image"
        src="/images/landing-bg.jpg"
      />
      {children}
    </div>
  )
}
